import {
  Box,
  Button,
  HStack,
  Switch,
  Td,
  Text,
  Tr,
  VStack,
} from '@chakra-ui/react';
import { MdEdit, MdOutlineCancel } from 'react-icons/md';
import { IoMdCheckmark } from 'react-icons/io';
import React from 'react';
import { diffRails } from '@views/FastTransferManager/utils';

const RailListCell = ({
  field,
  isSelected,
  formData,
  handleToggleChange,
}) => {
  const rails = field.value;

  return (
    <VStack align="stretch" spacing={2} py={1}>
      {Object.entries(rails).map(([railName, railCfg]) => (
        <HStack key={railName} justify="space-between" spacing={3}>
          <HStack spacing={2} flex={1}>
            <Text fontSize="xs" fontWeight="medium">
              {railName}
            </Text>
            <Text fontSize="xs" color="whiteAlpha.600">
              v{railCfg.activeVersion ?? '-'}
            </Text>
          </HStack>

          {isSelected && field.isEditable ? (
            <Switch
              isChecked={
                formData.enabledRails?.[railName]?.isEnabled ?? false
              }
              onChange={(e) =>
                handleToggleChange(railName, e.target.checked)
              }
              size="sm"
              colorScheme="brand"
            />
          ) : (
            <Switch
              isChecked={railCfg.isEnabled ?? false}
              isDisabled
              size="sm"
              colorScheme="brand"
            />
          )}
        </HStack>
      ))}
    </VStack>
  );
};

export const FastTransferRow = ({
  configEntity,
  configToEdit,
  formData,
  hasWriteAccess,
  handleToggleChange,
  handleEditMode,
  handleEditCleanUp,
  onConfirmUpdateModalOpen,
  getRowStyles,
}) => {
  const isSelected = configToEdit?.id === configEntity.id;

  const railsField = configEntity.data.find((f) => f.name === 'rails');
  const hasChanges =
    isSelected && railsField
      ? diffRails(railsField.value, formData.enabledRails).length > 0
      : false;

  return (
    <Tr key={configEntity.id} {...getRowStyles(configEntity)}>
      {configEntity.data.map((field, fieldIndex) => (
        <Td key={`${configEntity.id}-${fieldIndex}`}>
          {field.type === 'railList' ? (
            <Box
              transition="all 0.3s ease-in-out"
              transform={isSelected ? 'scale(0.9)' : 'scale(1)'}
            >
              <RailListCell
                field={field}
                isSelected={isSelected}
                formData={formData}
                handleToggleChange={handleToggleChange}
              />
            </Box>
          ) : (
            <HStack
              justify={
                field.name === 'countryCode'
                  ? 'space-between'
                  : 'space-evenly'
              }
              p={0}
              transition="all 0.3s ease-in-out"
              transform={isSelected ? 'scale(0.9)' : 'scale(1)'}
            >
              <Text fontSize="xs">
                {field.displayValue || field.maskValue || field.value || '-'}
              </Text>

              {field.name === 'countryCode' && hasWriteAccess && (
                <>
                  {isSelected ? (
                    <HStack justify="space-between">
                      <Button
                        colorScheme="red"
                        size="xs"
                        bg="black"
                        border="2px solid"
                        borderColor="whiteAlpha.500"
                        borderRadius="full"
                        onClick={handleEditCleanUp}
                        leftIcon={<MdOutlineCancel size="1rem" />}
                        p={3}
                      >
                        Discard
                      </Button>
                      <Button
                        colorScheme="brand"
                        size="xs"
                        bg="black"
                        border="2px solid"
                        borderColor="whiteAlpha.500"
                        borderRadius="full"
                        onClick={onConfirmUpdateModalOpen}
                        isDisabled={!hasChanges}
                        leftIcon={<IoMdCheckmark size="1rem" />}
                        p={3}
                      >
                        Update
                      </Button>
                    </HStack>
                  ) : (
                    <Button
                      colorScheme="brand"
                      size="xs"
                      bg="black"
                      border="1px solid"
                      borderColor="whiteAlpha.300"
                      borderRadius="lg"
                      p={0}
                      onClick={(e) => handleEditMode(e, configEntity)}
                    >
                      <MdEdit />
                    </Button>
                  )}
                </>
              )}
            </HStack>
          )}
        </Td>
      ))}
    </Tr>
  );
};
